import Product from 'src/app/model/product/product';
import SubProductDisplay from '../../shared-helper/sub-product-display';
import SubProductDisplayHelper from '../../shared-helper/sub-product-display-helper';

// TODO presentational logic from ProjectPlacerFormComponent should be moved here
export default class ProjectPlacerFormHelper {
  private constructor() {}

  public static getSubProductDisplays(product: Product): SubProductDisplay[] {
    return SubProductDisplayHelper.getSubProductDisplays(product);
  }
}
